import { InDevelopmentNote, InDevelopmentPage } from "../components/InDevelopment";

/** /ricerca: the header's «Ricerca», not there yet. */
export function RicercaPage() {
  return (
    <InDevelopmentPage title="Ricerca">
      <InDevelopmentNote feature="Ricerca">
        La ricerca per parole nelle news e nei documenti del Parlamento arriverà in un prossimo rilascio.
      </InDevelopmentNote>
    </InDevelopmentPage>
  );
}

/** /alert: the header's «Gestione alert», not there yet. */
export function AlertPage() {
  return (
    <InDevelopmentPage title="Gestione alert">
      <InDevelopmentNote feature="Gestione alert">
        Gli avvisi su parole chiave e fonti arriveranno in un prossimo rilascio.
      </InDevelopmentNote>
    </InDevelopmentPage>
  );
}
